import React from 'react';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';

const { string, func } = propTypes;

const makePhotosHtml = (photos, onPhotoClick, photoSetId) => {
	let photosHtml = [];
	photos.forEach((photo, photoIndex) => {
		let href = `#${photoSetId}-${photoIndex}`;
		photosHtml.push(
			<div className='vehicle-photo col-xs-12 col-sm-6 col-md-4 col-lg-3' key={photo.id}>
				<a href={href} onClick={(e) => onPhotoClick(e, photoSetId, photoIndex)}>
					<img className='vehicle-photo' src={photo.url} alt={photo.description} />
				</a>
				<div>{photo.description}</div>
			</div>
		);
	});
	return photosHtml;
};

function PhotoTabs (props) {
	const __ = mergeI18n(props.language, i18n);

	// create the HTML for the tabs and the current set of photos
	let photoTabs = [];
	let photos = (
		<p className='no-photos'>{__.noPhotosToDisplay}</p>
	);
	props.photoSets.forEach(photoSet => {
		// get the ID and the text to display for this tab
		let tabId = photoSet.id;
		let tabText = __.tabs[tabId];

		let tabProps = {key: tabId};
		if (tabId === props.currentPhotoTabId) {
			tabProps.className = 'active';

			// create the HTML for the active set of photos
			if (photoSet.photos.length) {
				photos = makePhotosHtml(photoSet.photos, props.onPhotoClick, tabId);
			}
		}

		// create the HTML for the tabs
		photoTabs.push(
			<li {...tabProps}>
				<a
					tabIndex={0}
					role='button'
					onClick={(e) => props.onTabClick(e, tabId)}
				>
					{tabText}
				</a>
			</li>
		);
	});

	return (
		<div id='photo-tabs'>
			<div className='row'>
				<div className='col-xs-12 col-sm-12 col-md-12'>
					<div className='panel with-nav-tabs panel-default'>
						<div className='panel-heading'>
							<ul className='nav nav-tabs'>
								{photoTabs}
							</ul>
						</div>
						<div className='panel-body'>
							<div className='tab-content'>
								<div className='tab-pane active'>
									<div className='row'>
										{photos}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

PhotoTabs.propTypes = {
	language: string.isRequired,
	currentPhotoTabId: string.isRequired,
	onTabClick: func.isRequired
};

export default PhotoTabs;
